module.exports = __webpack_public_path__ + "static/media/1POLICY18.9fa377ee.jpg";